/**
 * Encodes a URL for safe use, with special handling for characters
 * that encodeURI might not cover as desired (e.g., '+').
 *
 * @param {string} url The URL string to encode.
 * @returns {string} The encoded URL, or the original input if not a string.
 */
export const fixURL = (url) => {
  // if (typeof url !== 'string' || !url) {
  //   return url;
  // }

  // encodeURI correctly handles most characters, including converting spaces to %20.
  // We explicitly replace '+' with its URL-encoded value '%2B'.
  //return encodeURI(url).replace(/\+/g, '%2B');
  //console.log("fixURL", encodeURI(url));
  return encodeURI(url); // dont worry about the +
};